export default __webpack_public_path__ + "static/media/AnimalFeaturesSpots_09.fea5218f.png";